import { render, staticRenderFns } from "./OrderItemForm.vue?vue&type=template&id=1ccd422a&scoped=true&"
import script from "./OrderItemForm.vue?vue&type=script&lang=js&"
export * from "./OrderItemForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemForm.vue?vue&type=style&index=0&id=1ccd422a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd422a",
  null
  
)

export default component.exports